import { createFileRoute } from '@tanstack/react-router'
import {
  Card,
  CardContent,
  CardFooter,
  CardHeader,
  CardTitle,
} from '@/components/ui/card.jsx'
import { CheckCircle } from 'lucide-react'
import 'react'
import { useQuery } from '@tanstack/react-query'
import { saveZaloInfo } from '@/api/settings/channel.js'
import { useState } from 'react'
import QUERY_KEY from '@/constants/use-query-key.js'

export const Route = createFileRoute('/_callback/zalo-redirect')({
  component: RouteComponent,
})

function RouteComponent() {
  const searchParams = new URLSearchParams(window.location.search)
  const params = Object.fromEntries(searchParams.entries())
  const [errorMessage, setErrorMessage] = useState(null)
  useQuery({
    queryKey: QUERY_KEY.POST_SAVE_ZALO_INFO,
    queryFn: async () => {
      try {
        const result = await saveZaloInfo({ params })
        setErrorMessage(result.error || null)
        // eslint-disable-next-line no-unused-vars
      } catch (error) {
        // setErrorMessage('Đã xảy ra lỗi khi thêm mới Zalo OA!')
      }
      if (window.opener) {
        setTimeout(() => {
          window.opener.postMessage('zaloSaveEnded', '*')
          window.close()
        }, 1000)
      }
    },
    staleTime: 0, // Disable stale time
    refetchInterval: 0, // Disable refetching
  })
  return (
    <div className="container grid h-svh max-w-none flex-col items-center justify-center bg-primary-foreground px-0">
      <Card className="w-[480px]">
        <CardHeader></CardHeader>
        <CardContent>
          <div className="flex items-center gap-2">
            <CheckCircle className="h-8 w-8 text-destructive" />
            <CardTitle
              className={
                errorMessage
                  ? 'text-2xl text-[--label-red-foreground]'
                  : 'text-2xl text-[--label-green-prime]'
              }
            >
              {errorMessage || 'Đã thêm mới Zalo OA thành công!'}
            </CardTitle>
          </div>
        </CardContent>
        <CardFooter></CardFooter>
      </Card>
    </div>
  )
}
